import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";

export const getDashboardStatsApi = async (trainerId?: string) => {
  const url = trainerId
    ? `${AXIOS_ROUTES.dashboard.getDashboardStats}?trainerId=${trainerId}`
    : AXIOS_ROUTES.dashboard.getDashboardStats;
  return await axiosInstance.get(url);
};

export const getTraineeCountsApi = async (
  type: "training-programs" | "workouts",
  skip: number,
  limit: number,
  trainerId?: string
) => {
  let url = "";
  if (type === "training-programs") {
    url = trainerId
      ? `${AXIOS_ROUTES.dashboard.getTrainingProgramsTraineeCounts}?trainerId=${trainerId}&skip=${skip}&limit=${limit}`
      : `${AXIOS_ROUTES.dashboard.getTrainingProgramsTraineeCounts}?skip=${skip}&limit=${limit}`;
  } else {
    url = trainerId
      ? `${AXIOS_ROUTES.dashboard.getWorkoutsTraineeCounts}?trainerId=${trainerId}&skip=${skip}&limit=${limit}`
      : `${AXIOS_ROUTES.dashboard.getWorkoutsTraineeCounts}?skip=${skip}&limit=${limit}`;
  }

  return await axiosInstance.get(url);
};

export const getRevenuesApi = async (body: any, trainerId?: string) => {
  const url = trainerId
    ? `${AXIOS_ROUTES.dashboard.getRevenues}?trainerId=${trainerId}`
    : AXIOS_ROUTES.dashboard.getRevenues;
  return await axiosInstance.post(url, body);
};
